import { useMemo, useState } from "react";
import { faqCategories, faqItems } from "@/mocks/home";

export default function Faq() {
  const [category, setCategory] = useState(faqCategories[0]);
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const list = useMemo(
    () => (category === "全部" ? faqItems : faqItems.filter((item) => item.cat === category)),
    [category],
  );

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            常见问题解答
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            下面按类别整理了访问过程中最常被问到的问题。点击分类可以快速筛选，点击问题即可展开查看完整回答。
          </p>
        </div>

        <div className="mt-8 inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-50 border border-background-200/70">
          {faqCategories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => {
                setCategory(cat);
                setOpenIndex(0);
              }}
              aria-pressed={category === cat}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                category === cat
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:bg-background-100"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3">
          {list.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`rounded-lg bg-background-50 border border-background-200/70 overflow-hidden self-start ${
                  isOpen ? "md:col-span-2" : ""
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center gap-3 p-4 text-left cursor-pointer"
                >
                  <span className="flex-none px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                    {item.cat}
                  </span>
                  <span className="flex-1 text-sm md:text-base font-medium text-foreground-900">
                    {item.q}
                  </span>
                  <i
                    className={`flex-none text-foreground-500 transition-transform ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-4 pb-5">
                    <p className="text-xs md:text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}